import { useEffect, useState } from "react";
import { use_store } from "../store";
import Button from "./button";
import { SignUp, SignIn, UserProfile } from "@clerk/clerk-react";

// Clerk appearance configuration
const appearance = {
  elements: {
    headerTitle: {
      fontWeight: "500",
      fontSize: "24px",
    },
    headerSubtitle: {
      fontSize: "14px",
    },
    dividerText: {
      fontSize: "12px",
    },
    formFieldLabel: {
      fontSize: "14px",
      fontWeight: "400",
    },
    formButtonPrimary: {
      fontFamily: "'HvDTrial Match'",
      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "normal",
      width: "100%",
    },
    footerActionText: {
      fontSize: "14px",
    },
  },
  layout: {
    logoPlacement: "none" as const,
    showOptionalFields: true,
  },
  variables: {
    colorPrimary: "#8A3BEE",
    colorDanger: "#F200B7",
    colorSuccess: "#8A3BEE",
    colorWarning: "#FE9402",
    colorTextOnPrimaryBackground: "#FFFFFF",
    fontFamily: "'HvDTrial Match', system-ui, sans-serif",
    fontSize: "14px",
    borderRadius: "4px",
    spacingUnit: "16px",
  },
};

export default function AccountPageV2({
  account_mode,
}: {
  account_mode: string;
}) {
  const { user, t, set_tool, ln, session_unique_id } = use_store();
  const [account_management_mode, set_account_management_mode] =
    useState(account_mode);

  useEffect(() => {
    set_tool(undefined);
  }, []);

  useEffect(() => {
    if (user?.email) {
      set_account_management_mode("logged-in");
    }
  }, [user, ln]);

  return (
    <div className="flex flex-col w-full items-center justify-start min-h-screen pb-[40px]">
      {(account_management_mode === "create" ||
        account_management_mode === "login") && (
        <>
          {account_management_mode === "create" && (
            <>
              <div className="flex flex-col gap-[16px] w-full max-w-[400px]">
                <SignUp
                  appearance={appearance}
                  forceRedirectUrl={
                    ln
                      ? `/${ln}/pay?unique_id=${session_unique_id}`
                      : `/pay?unique_id=${session_unique_id}`
                  }
                  signInForceRedirectUrl={
                    ln
                      ? `/${ln}/pay?unique_id=${session_unique_id}`
                      : `/pay?unique_id=${session_unique_id}`
                  }
                  signInUrl={ln ? `/${ln}/login` : "/login"}
                />
              </div>
            </>
          )}
          {account_management_mode === "login" && (
            <>
              <SignIn appearance={appearance} forceRedirectUrl={"/"} />
            </>
          )}
        </>
      )}
      {account_management_mode === "logged-in" && (
        <>
          <div className="flex flex-col pb-[40px] items-center w-full">
            {!user?.subscribed && (
              <div className="w-full">
                <Button
                  secondary_style={false}
                  href={
                    ln
                      ? `/${ln}/pay?unique_id=${session_unique_id}`
                      : `/pay?unique_id=${session_unique_id}`
                  }
                >
                  {t("Become Elite")}
                </Button>
              </div>
            )}
            <div className="m-[16px] flex flex-col gap-[12px] pb-[40px]">
              <UserProfile appearance={appearance} />
            </div>
            <div className="w-full">
              {user?.subscribed && (
                <Button secondary_style={true} href={user.billing_url}>
                  {t("Manage Subscription")}
                </Button>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
